import { DealSource, DealStage, DealType, DealReasonForLoss, LeadSource, LeadStatus, LeadIndustry, LeadRating, AccountIndustry, AccountOwnership, AccountRating, AccountType, CampaignStatus, CampaignType } from "../../utils/enums";
import AccountsAutoComplete from "../Accounts/AccountsAutoComplete";
import CampaignsAutoComplete from "../Campaigns/CampaignsAutoComplete";
import ContactsAutoComplete from "../Contacts/ContactsAutoComplete";
import UsersAutoComplete from "../Users/UsersAutoComplete";
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, MenuItem, Autocomplete, Box } from "@mui/material";
import { Popper } from '@mui/material';
import dayjs from 'dayjs';
import DateRangePicker from "./DateRangePicker";

const FilterValueInput = ({ selectedField, filter, index, handleChange, module }) => {
    const showUsers = ["CreatedBy", "OwnerId"];

    if (showUsers.includes(selectedField?.fieldName)) {
        return <UsersAutoComplete
            userId={filter?.value} // Use value from selectedFilters
            setUserId={(newValue) => handleChange(index, "value", newValue.toString())} // Map setUserId to handleChange
            small={true}
            fullWidth={false} />;
    }

    if (selectedField?.fieldName == "AccountId") {
        return <AccountsAutoComplete
            accountId={filter?.value}
            setAccountId={(newValue) => handleChange(index, "value", newValue.toString())}
            small={true}
            fullWidth={false}
            shouldFetchSingleAccount={filter?.value > 0} />;
    }

    if (selectedField?.fieldName == "ContactId") {
        return <ContactsAutoComplete
            contactId={filter?.value}
            setContactId={(newValue) => handleChange(index, "value", newValue.toString())}
            small={true}
            fullWidth={false}
            shouldFetchSingleContact={filter?.value > 0} />;
    }

    if (selectedField?.fieldName == "CampaignId") {
        return <CampaignsAutoComplete
            campaignId={filter?.value}
            setCampaignId={(newValue) => handleChange(index, "value", newValue.toString())}
            small={true}
            fullWidth={false}
            shouldFetchSingleCampaign={filter?.value > 0} />;
    }

    // deal enums
    if (module == 3) {

        if (selectedField?.fieldName == "Type") {
            return <Autocomplete
                disablePortal
                options={DealType}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? DealType.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Deal Type" />}
            />

            //also handle for campaign
        }

        if (selectedField?.fieldName == "Stage") {
            return <Autocomplete
                disablePortal
                options={DealStage}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? DealStage.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Deal Stage" />}
            />
        }

        // this needs to be handled, because there are two LeadSource's, one in Lead one in Deal
        if (selectedField?.fieldName == "LeadSource") {
            return <Autocomplete
                disablePortal
                options={DealSource}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? DealSource.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Lead Source" />}
            />
        }

        if (selectedField?.fieldName == "ReasonForLoss") {
            return <Autocomplete
                disablePortal
                options={DealReasonForLoss}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? DealReasonForLoss.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Reason For Loss" />}
            />
        }

    }

    // lead/contact
    if (module == 2 || module == 4) {
        if (selectedField?.fieldName == "LeadSource") {
            return <Autocomplete
                disablePortal
                options={LeadSource}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? LeadSource.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Lead Source" />}
            />
        }
        if (selectedField?.fieldName == "LeadStatus") {
            return <Autocomplete
                disablePortal
                options={LeadStatus}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? LeadStatus.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Lead Status" />}
            />
        }
        if (selectedField?.fieldName == "Industry") {
            return <Autocomplete
                disablePortal
                options={LeadIndustry}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? LeadIndustry.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Industry" />}
            />
        }
        if (selectedField?.fieldName == "Rating") {
            return <Autocomplete
                disablePortal
                options={LeadRating}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? LeadRating.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Rating" />}
            />
        }
    }

    // account
    if (module == 0) {
        if (selectedField?.fieldName == "AccountType") {
            return <Autocomplete
                disablePortal
                options={AccountType}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? AccountType.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Account Type" />}
            />
        }
        if (selectedField?.fieldName == "Industry") {
            return <Autocomplete
                disablePortal
                options={AccountIndustry}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? AccountIndustry.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Account Industry" />}
            />
        }
        if (selectedField?.fieldName == "Rating") {
            return <Autocomplete
                disablePortal
                options={AccountRating}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? AccountRating.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Account Rating" />}
            />
        }
        if (selectedField?.fieldName == "Ownership") {
            return <Autocomplete
                disablePortal
                options={AccountOwnership}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? AccountOwnership.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Account Ownership" />}
            />
        }
    }

    if (module == 1) {
        if (selectedField?.fieldName == "Type") {
            return <Autocomplete
                disablePortal
                options={CampaignType}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? CampaignType.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Campaign Type" />}
            />
        }
        if (selectedField?.fieldName == "Status") {
            return <Autocomplete
                disablePortal
                options={CampaignStatus}
                size="small"
                value={filter?.value !== undefined && filter?.value !== null && filter?.value !== ""
                    ? CampaignStatus.find((option) => option.value === Number(filter.value))
                    : null}
                onChange={(event, newValue) => handleChange(index, "value", newValue ? newValue.value.toString() : '')}
                renderInput={(params) => <TextField {...params} label="Campaign Status" />}
            />
        }
    }



    if (selectedField?.dataType == "DateTime") {
        if (filter?.operator === 14) {
            return <DateRangePicker index={index} filter={filter} handleChange={handleChange} />
        }
        else {
            return <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="Date"
                    fullWidth
                    value={filter?.value ? dayjs(filter.value) : null}
                    onChange={(newDate) => {
                        handleChange(index, "value", newDate.format('YYYY-MM-DD'));
                    }}
                    slotProps={{
                        textField: {
                            variant: 'outlined',
                            size: "small",
                            fullWidth: true,
                        },
                    }}
                />
            </LocalizationProvider>
        }
    }

    else {
        return (
            <>
                <TextField
                    fullWidth
                    value={filter?.value}
                    onChange={(e) => handleChange(index, "value", e.target.value)}
                    size="small"
                    sx={{ flex: 1 }}
                />
            </>
        )
    }
}

export default FilterValueInput